(function () {
  var LABELS = {
    nl: { constellations: 'Sterrenbeelden', milky_way: 'Melkweg',      grid_lines: 'Rasterlijnen' },
    fr: { constellations: 'Constellations',  milky_way: 'Voie lactée',  grid_lines: 'Lignes de grille' },
    de: { constellations: 'Sternbilder',     milky_way: 'Milchstraße',  grid_lines: 'Gitterlinien' }
    // en: keep Teeinblue defaults
  };

  function getLocale() {
    var l = (window.starlitLocale || document.documentElement.lang || 'en').toLowerCase();
    if (l.indexOf('nl') === 0) return 'nl';
    if (l.indexOf('fr') === 0) return 'fr';
    if (l.indexOf('de') === 0) return 'de';
    return 'en';
  }

  function translate(root) {
    try {
      var t = LABELS[getLocale()];
      if (!t) return;

      // Scope queries to the Teeinblue form container (faster + safer)
      var c = root.querySelector('label[for*="option-constellations"] span');
      var m = root.querySelector('label[for*="option-mw"] span');
      var g = root.querySelector('label[for*="option-lines"] span');

      if (c) c.textContent = t.constellations;
      if (m) m.textContent = t.milky_way;
      if (g) g.textContent = t.grid_lines;
    } catch (e) {
      console.warn('Teeinblue label translation error:', e);
    }
  }

  function attach(root) {
    // Initial translate when the form first appears
    translate(root);

    if (!('MutationObserver' in window)) return;

    // Debounce to avoid “lock” during DOM bursts
    var scheduled = false;
    var obs = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        translate(root);
      });
    });

    obs.observe(root, { childList: true, subtree: true });
  }

  function init() {
    var tries = 0;
    var maxTries = 40;      // 40 * 250 ms = 10 seconds max wait
    var intervalMs = 250;

    var timer = setInterval(function () {
      tries += 1;

      var root = document.getElementById('teeFormInputs');
      if (root) {
        clearInterval(timer);
        attach(root);
        return;
      }

      if (tries >= maxTries) {
        clearInterval(timer);
      }
    }, intervalMs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
